import { useGetProfile } from 'api/generated/profile/profile'

const PROVIDER_SCRIPT_SURE_COHORT = 'ProviderScriptSure'

export function useIsProviderScriptSureCohort(): boolean {
  const { data: profile } = useGetProfile()
  return profile?.Cohorts?.includes(PROVIDER_SCRIPT_SURE_COHORT) ?? false
}
